export default __webpack_public_path__ + "static/media/LibreFranklin-Thin.01794f7e.ttf";